import { CustomIconsType } from '../../../types/common';

export const AppleLogo = ({ size = 32, fill = 'black' }: CustomIconsType) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4571 8.08385C19.336 8.17736 17.1976 9.37636 17.1976 12.0424C17.1976 15.1261 19.9186 16.2171 20 16.2441C19.9875 16.3106 19.5677 17.7382 18.5654 19.1928C17.6717 20.4728 16.7382 21.7508 15.3183 21.7508C13.8983 21.7508 13.5329 20.93 11.8936 20.93C10.2962 20.93 9.72817 21.7778 8.42931 21.7778C7.13045 21.7778 6.22417 20.5933 5.18216 19.1387C3.97519 17.4306 3 14.777 3 12.2585C3 8.21892 5.63948 6.07652 8.23719 6.07652C9.61749 6.07652 10.7681 6.97836 11.6347 6.97836C12.4595 6.97836 13.7459 6.02249 15.3162 6.02249C15.9113 6.02249 18.0496 6.07652 19.4571 8.08385ZM14.5707 4.31231C15.2201 3.54553 15.6795 2.4816 15.6795 1.41768C15.6795 1.27014 15.667 1.12052 15.6398 1C14.5832 1.03948 13.3261 1.70028 12.5681 2.57511C11.973 3.24838 11.4175 4.31231 11.4175 5.39078C11.4175 5.55287 11.4447 5.71495 11.4572 5.7669C11.524 5.77937 11.6326 5.79391 11.7412 5.79391C12.6892 5.79391 13.8816 5.1622 14.5707 4.31231Z"
        fill={fill}
      />
    </svg>
  );
};
